<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20 blog-categories">
      <!-- <h3>{{'All categories'|translate}}</h3> -->

      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'Home', params: {}}">{{'Home'|translate}}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'AllPosts', params: {  }}">{{'All posts'|translate}}</router-link>
        </li>
        <li class="active">{{'Categories'|translate}}</li>
      </ol>

      <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>

      <p
        class="mt20 alert alert-info"
        v-if="list_items && list_items.length == 0"
      >{{'There is categories'|translate}}</p>
      <div class="row" v-if="list_items && list_items.length > 0">
        <div class="col-xs-6 col-md-4" v-for="(item) in list_items" :key="item.id">
          <div class="media">
            <div class="media-left">
              <img :src="item.thumb" class="media-object" style="width:80px" />
            </div>
            <div class="media-body media-middle">
              <p class="title">
                <router-link
                  :to="{ name: 'BlogCatPosts', params: { cat_id: item.id,cat_slug:item.slug }}"
                >{{item.name}}</router-link>
              </p>

              <p>{{'Count posts'|translate}} : {{item.count_posts}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <form-store v-if="show_form && all_products.length > 0" ref="formstore" :all_products="all_products" :pass_data="pass_data"  @modalData="modalData"  ></form-store> -->
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
// import FormStore from '@/components/forms/FormStore'

import Loading from "@/components/elements/Loading";
export default {
  name: "Home",
  components: {
    MyHeader,
    Loading
  },
  data() {
    return {
      list_items: null,
      page: 1,
      offset: 0,
      keyword: ""
    };
  },
  methods: {
    list() {
      Utils.request(this, true, "blog")
        .get(`/categories/`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.list_items = data.data;
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },

    search() {
      console.log("keyword", this.keyword);
      this.list();
    }
  },
  mounted() {
    this.list();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blog/BlogCategories.vue